<section class="sign-in-page">
  <!-- Brand area -->
  <header class="brand-header">
    <img class="mobydyg-logo" src="../../../assets/static/mobydyg.png" alt="MobyDyg Logo">
  </header>

  <!-- Step 1: Credentials -->
  <article class="auth-card" [@slideLeft]="state" *ngIf="currentStep === 1">
    <div class="auth-content" *ngIf="!needsNewPassword; else ChangePasswordRequest" [@inOutAnimation]>
      <header class="card-header">
        <h1>Iniciar sesión</h1>
        <p>Accede al panel de administración de tu tienda.</p>
      </header>

      <form action="post" [formGroup]="signInForm" class="auth-form" novalidate>
        <div class="alert-span-exeption" aria-live="polite">
          <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{ exceptionMessage }}</span>
        </div>

        <div class="form-field">
          <label for="givenEmail">Correo electrónico</label>
          <input
            id="givenEmail"
            type="email"
            name="email"
            placeholder="tu@empresa.com"
            class="textInput"
            formControlName="givenEmail"
            autocomplete="username"
            (input)="exceptionMessage = ''"
          >
        </div>

        <div class="form-field">
          <label for="givenPassword">Contraseña</label>
          <div class="password-input">
            <input
              id="givenPassword"
              [type]="isPasswordVisible ? 'text':'password'"
              name="password"
              placeholder="Ingresa tu contraseña"
              class="textInput"
              formControlName="givenPassword"
              autocomplete="current-password"
              (input)="exceptionMessage = ''"
            >
            <button
              type="button"
              class="password-toggle"
              (click)="isPasswordVisible = !isPasswordVisible"
              aria-label="Mostrar u ocultar contraseña"
            >
              <i class="password-icon" [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"></i>
            </button>
          </div>
        </div>

        <div class="form-meta">
          <div class="checkboxContainer">
            <input
              type="checkbox"
              name="remember-me"
              class="checkboxInput"
              [value]="true"
              id="remember-me"
              (change)="onRememberMe($event)"
              [checked]="rememberMe"
            >
            <label for="remember-me">Recordar usuario</label>
          </div>
          <a class="a-link a-password-recovery" (click)="recoveryPassword()">Olvidé mi contraseña</a>
        </div>

        <div class="loading" *ngIf="isLoginSubmitting">
          <div class="spinner-border" role="status" aria-label="Cargando"></div>
        </div>

        <div class="form-buttons d-flex-column" *ngIf="!isLoginSubmitting">
          <button type="button" (click)="nextStep($event)" class="submit-btn">Siguiente</button>
        </div>
      </form>

      <p class="footer-note">© 2026 MobyDyg, v 2.0.1</p>
    </div>
  </article>

  <!-- Step 3: Shop selection -->
  <article class="auth-card" [@slideLeft]="state" *ngIf="currentStep === 3">
    <div class="auth-content" *ngIf="!needsNewPassword; else ChangePasswordRequest" [@inOutAnimation]>
      <div class="loading loading-shop-selection" *ngIf="loading" aria-live="polite">
        <div class="spinner-border" role="status" aria-label="Procesando acceso"></div>
        <span class="loading-text">Procesando tu acceso, por favor espera...</span>
      </div>

      <header *ngIf="!loading" class="card-header">
        <h1>Selecciona tu tienda</h1>
        <p>Elige la tienda que deseas administrar.</p>
      </header>

      <form action="post" [formGroup]="signInForm" class="auth-form" novalidate *ngIf="!loading">
        <div class="alert-span-exeption" aria-live="polite">
          <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{ exceptionMessage }}</span>
        </div>

        <div class="form-field">
          <label class="label-left" for="givenSelectedShop">Tienda</label>
          <select id="givenSelectedShop" class="form-select" formControlName="givenSelectedShop" [disabled]="loading">
            <option *ngFor="let shop of shops" [value]="shop.shopDomain">
              {{ shop.shopName }}
            </option>
          </select>
        </div>

        <div class="form-buttons d-flex">
          <button type="button" (click)="prevStep($event)" class="submit-btn button-secondary" [disabled]="loading">Anterior</button>
          <button type="button" (click)="nextStep($event)" class="submit-btn" [disabled]="loading">Siguiente</button>
        </div>
      </form>
    </div>
  </article>

  <!-- Step 2: MFA verification -->
  <article class="auth-card" [@slideLeft]="state" *ngIf="currentStep === 2">
    <div class="auth-content" [@inOutAnimation]>
      <header class="card-header">
        <h1 *ngIf="verificationMode === 'MFA'">
          {{ mfaChallenge === 'EMAIL_OTP'
              ? 'Código enviado a tu correo'
              : 'Código de tu app de autenticación' }}
        </h1>
        <p *ngIf="verificationMode === 'MFA'">
          {{ mfaChallenge === 'EMAIL_OTP'
              ? 'Revisa tu correo e ingresa el código que te enviamos.'
              : 'Ingresa el código generado por tu aplicación autenticadora.' }}
        </p>
        <h1 *ngIf="verificationMode === 'PHONE'">Verifica tu teléfono</h1>
        <p *ngIf="verificationMode === 'PHONE' && codeSent">
          {{
            phoneDestinationMasked
              ? ('Te enviamos un código por SMS a ' + phoneDestinationMasked + '. Ingresa el código para continuar.')
              : 'Te enviamos un código por SMS. Ingresa el código para continuar.'
          }}
        </p>
        <p *ngIf="verificationMode === 'PHONE' && !codeSent">
          {{
            phoneRequiresInput
              ? 'Selecciona tu país e ingresa tu número local para recibir el código por SMS.'
              : 'Para verificar tu número de teléfono, presiona el botón para recibir un código por SMS.'
          }}
        </p>
      </header>

      <form class="auth-form" novalidate>
        <div class="form-field" *ngIf="verificationMode === 'PHONE'">
          <label for="onboardingPhoneNumber">Teléfono</label>
          <div class="phone-input-row">
            <select
              id="phoneCountry"
              class="form-select phone-country-select"
              name="phoneCountry"
              [(ngModel)]="selectedPhoneCountryCode"
              (ngModelChange)="onPhoneCountryChange()"
              [disabled]="isOtpVerifying || isResendingCode || !phoneRequiresInput"
            >
              <option *ngFor="let country of supportedPhoneCountries" [ngValue]="country.code">
                {{ country.name }} ({{ country.prefix }})
              </option>
            </select>
            <input
              id="onboardingPhoneNumber"
              type="text"
              [(ngModel)]="onboardingPhoneNumber"
              name="onboardingPhoneNumber"
              class="textInput"
              placeholder="70654328"
              inputmode="numeric"
              autocomplete="tel-local"
              (ngModelChange)="onLocalPhoneNumberChange($event)"
              [disabled]="isOtpVerifying || isResendingCode || !phoneRequiresInput"
            />
          </div>
        </div>

        <div class="form-buttons d-flex" *ngIf="verificationMode === 'PHONE'">
          <button
            type="button"
            class="submit-btn"
            (click)="sendPhoneVerificationCode()"
            [disabled]="isOtpVerifying || isResendingCode || (phoneRequiresInput && !onboardingPhoneNumber)"
          >
            Enviar código
          </button>
        </div>

        <div class="form-field otp-field-container" *ngIf="verificationMode === 'MFA' || (verificationMode === 'PHONE' && codeSent)">
          <label>Código de verificación</label>
          <app-otp-input
            #otpInputRef
            [otpLength]="6"
            [isDisabled]="isOtpVerifying"
            (otpChange)="onOtpChange($event)"
          ></app-otp-input>
        </div>

        <div class="form-buttons d-flex">
          <button
            type="button"
            (click)="prevStep($event)"
            class="submit-btn button-secondary"
            [disabled]="isOtpVerifying"
          >
            Anterior
          </button>
          <button
            type="button"
            class="submit-btn"
            *ngIf="verificationMode === 'MFA' || (verificationMode === 'PHONE' && codeSent)"
            (click)="verifyCode()"
            [disabled]="isOtpVerifying || (verificationMode === 'MFA' && !isOtpComplete)"
          >
            Verificar
          </button>
        </div>

        <div class="resend-code" *ngIf="showResendCodeAction">
          <span class="resend-code-text">¿No recibiste el código?</span>
          <button
            type="button"
            class="resend-code-btn"
            (click)="resendVerificationCode()"
            [disabled]="isResendButtonDisabled"
          >
            {{ resendButtonLabel }}
          </button>
        </div>

        <div class="loading" *ngIf="isOtpVerifying">
          <div class="spinner-border" role="status" aria-label="Verificando"></div>
          <span class="loading-text">Verificando código...</span>
        </div>

        <p class="error-message text-center" aria-live="polite" *ngIf="exceptionMessage">
          {{ exceptionMessage }}
        </p>
      </form>
    </div>
  </article>
</section>

<ng-template #ChangePasswordRequest>
  <div class="auth-content password-change" [@inOutAnimation]>
    <header class="card-header">
      <h1>Cambiar contraseña</h1>
      <p class="info-message">Es necesario cambiar su contraseña.</p>
    </header>

    <form action="post" [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()" class="auth-form" novalidate>
      <div class="alert-span-exeption" aria-live="polite">
        <span *ngIf="exceptionMessage != ''" [@inOutAnimation] class="error-message">{{ exceptionMessage }}</span>
      </div>

      <div class="alert-span"
        *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].invalid">
        <label class="error-message"
          *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].errors && changePasswordFormValidation['newPassword'].errors['required']"
          [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message"
          *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].errors && changePasswordFormValidation['newPassword'].errors['pattern']"
          [@inOutAnimation]>
          Formato incorrecto
        </label>
      </div>

      <div class="form-field">
        <label for="newPassword">Nueva contraseña</label>
        <div class="password-input">
          <input
            id="newPassword"
            [type]="isPasswordVisible ? 'text':'password'"
            name="password"
            placeholder="Ingresa tu nueva contraseña"
            class="textInput"
            formControlName="newPassword"
            autocomplete="new-password"
            (focus)="exceptionMessage = ''"
          >
          <button
            type="button"
            class="password-toggle"
            (click)="isPasswordVisible = !isPasswordVisible"
            aria-label="Mostrar u ocultar nueva contraseña"
          >
            <i class="password-icon" [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"></i>
          </button>
        </div>
      </div>

      <div class="alert-span password-requirements">
        <span>La contraseña debe contener:</span>
        <ul>
          <li><span>Una longitud de 8 a 16 caracteres</span></li>
          <li><span>Al menos una letra en mayúscula</span></li>
          <li><span>Al menos una letra en minúscula</span></li>
          <li><span>Un número</span></li>
        </ul>
      </div>

      <div class="alert-span"
        *ngIf="changePasswordFormValidation['confirmNewPassword'].touched && changePasswordFormValidation['confirmNewPassword'].invalid">
        <label class="error-message"
          *ngIf="changePasswordFormValidation['confirmNewPassword'].errors && changePasswordFormValidation['confirmNewPassword'].errors['required']"
          [@inOutAnimation]>
          Este campo es requerido
        </label>
        <label class="error-message"
          *ngIf="changePasswordFormValidation['confirmNewPassword'].errors && changePasswordFormValidation['confirmNewPassword'].errors['matching']"
          [@inOutAnimation]>
          Las contraseñas no coinciden
        </label>
      </div>

      <div class="form-field">
        <label for="confirmNewPassword">Confirmar contraseña</label>
        <div class="password-input">
          <input
            id="confirmNewPassword"
            [type]="isConfirmPasswordVisible ? 'text':'password'"
            name="confirmNewPassword"
            placeholder="Confirma tu contraseña"
            class="textInput"
            formControlName="confirmNewPassword"
            autocomplete="new-password"
            (focus)="exceptionMessage = ''"
          >
          <button
            type="button"
            class="password-toggle"
            (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible"
            aria-label="Mostrar u ocultar confirmación de contraseña"
          >
            <i class="password-icon" [ngClass]="isConfirmPasswordVisible ? 'hide-password' : 'show-password'"></i>
          </button>
        </div>
      </div>

      <div class="form-buttons d-flex-column password-form">
        <button
          type="submit"
          [disabled]="changePasswordForm.invalid || isPasswordChanging"
          class="submit-btn"
        >
          Continuar
        </button>
      </div>

      <div class="loading" *ngIf="isPasswordChanging">
        <div class="spinner-border" role="status" aria-label="Actualizando contraseña"></div>
      </div>
    </form>
  </div>
</ng-template>
